"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var findPeople_1 = require("../services/findPeople");
var processFindPeopleResult_1 = require("owa-recipient-common/lib/actions/processFindPeopleResult");
var legacy_1 = require("satcheljs/lib/legacy");
var MAX_RESULTS_DEFAULT = 50;
var MAX_RESULTS_SECONDARY_SEARCH = 10;
var STARTING_OFFSET = 0;
exports.default = legacy_1.action('populateContactPicker')(function populateContactPicker(viewState, offset, maxResults) {
    if (offset === void 0) { offset = STARTING_OFFSET; }
    if (maxResults === void 0) { maxResults = MAX_RESULTS_DEFAULT; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var findPeopleResult, findResultSet, newOffset, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    viewState.isLoading = true;
                    return [4 /*yield*/, findPeople_1.findPeople(offset, maxResults)];
                case 1:
                    findPeopleResult = _b.sent();
                    findResultSet = [];
                    processFindPeopleResult_1.default(findResultSet, findPeopleResult);
                    viewState.isLoading = false;
                    viewState.maxForSession = findPeopleResult.TotalNumberOfPeopleInView;
                    (_a = viewState.contacts).splice.apply(_a, [offset, findResultSet.length].concat(findResultSet));
                    newOffset = offset + findResultSet.length;
                    if (newOffset < viewState.maxForSession) {
                        populateContactPicker(viewState, newOffset, Math.min(MAX_RESULTS_SECONDARY_SEARCH, viewState.maxForSession - newOffset));
                    }
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=populateContactPicker.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-contact-picker/lib/actions/populateContactPicker.js
// module id = 5205
// module chunks = 99